import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';

import { AgentsAttentionPage } from '@/features/agents/agents-attention-page';
import { isAgentsUxEnabled } from '@/features/agents/agents.utils';
import { Routes } from '@/types/routes';

export const Route = createFileRoute('/_authenticated/agents/attention')({
  component: AgentsAttentionPage,
  validateSearch: z.object({
    agent: z.string().optional(),
  }),
  beforeLoad: () => {
    if (!isAgentsUxEnabled()) {
      throw redirect({ to: Routes.Chats as string, replace: true });
    }
  },
});
